
import { ReactChart } from 'chartjs-react';
import { Chart, registerables } from 'chart.js';
import { useEffect } from 'react';
import TenantServices from './../../services/TenantServices';
import { useState } from 'react';
Chart.register(...registerables);
 export default function TransferGraph(){
  const [graphData, setGraphData] = useState({})
  const [dataOpt, setDataOpt] = useState({
    plugins: {
      legend: {
        display: true,
        position: 'top',
        labels: {
          boxWidth: 10,
          usePointStyle: true,
          pointStyle: "line"
        }
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        },
        title: {
          display: true,
          text: "Transfer",
          color: "red",
          font: {
            size: 24,
            weight: "bold"
          }
        }
      },
      y: {
        grid: {
          color: "#ccc",
          borderDash: [5, 1],
          borderColor: "black",
          tickColor: "black"
        },
        title: {
          display: true,
          text: "",
          color: "green",
          font: {
            size: 18,
            weight: "bold"
          }
        }
      }
    }
  })


  
      const trnxGraph = async () => {
        var labels = [];
        var successfulData = [];
        var failedData = [];
        const resp = await TenantServices.transferGraph();
        
        resp.data.map(data => {
            successfulData.push(data.successSum );
            failedData.push(data.failedSum );
            labels.push(data.date );
        })
        var options = {
          labels: [...labels],
          datasets: [{
            label: "Successful Transfer",
            data: [...successfulData],
            lineTension: 0,
            fill: false,
            borderColor: 'green',
            backgroundColor: 'transparent',
            pointBorderColor: 'green',
            pointBackgroundColor: 'green',
            borderDash: [15, 5],
            pointRadius: 5,
            pointHoverRadius: 10,
            pointHitRadius: 30,
            pointBorderWidth: 2,
            pointStyle: 'rectRounded'
          },
          {
            label: "Failed Transfer",
            data: [...failedData],
            lineTension: 0,
            fill: false,
            borderColor: 'red',
            backgroundColor: 'transparent',
            pointBorderColor: 'red',
            pointBackgroundColor: 'red',
            borderDash: [15, 5],
            pointRadius: 5,
            pointHoverRadius: 10,
            pointHitRadius: 30,
            pointBorderWidth: 2,
            pointStyle: 'rectRounded'
          }]
        };
      
      
    setGraphData(options);
     

    }

    useEffect(() => {
        trnxGraph();
    }, [])
    return(
        <>
        <ReactChart
      type="line"
      data={graphData}
      options={dataOpt}
      width={100}
    />
        </>
    )
 }